import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { TfiLock } from 'react-icons/tfi';
import { HiOutlineDeviceMobile } from 'react-icons/hi';
import s from './style.css';
import { colors } from '../../foundations';
import { auth } from '../../actions';
const PasswordRecovery = (props) => {
    useEffect(() => {
        props.fetchDevices();
    }, []);
    return (React.createElement("div", { className: s.formContainer },
        React.createElement("div", { className: s.keyCircle },
            React.createElement(TfiLock, { size: 60, color: colors.primary })),
        React.createElement("p", { style: { marginTop: 40, marginBottom: 20 } },
            "You can recover your password from your ",
            React.createElement("span", { style: { fontFamily: 'Sirin Stencil' } }, "Sticknet"),
            ' ',
            "account on one of your mobile devices:"),
        props.devices.map((device) => {
            return (React.createElement("div", { key: device.id, className: s.deviceItem },
                React.createElement(HiOutlineDeviceMobile, { size: 20, color: colors.black }),
                React.createElement("p", { className: s.deviceName }, device.name)));
        }),
        React.createElement("p", { style: { marginTop: 20, alignSelf: 'flex-start' } },
            "Go to Profile ",
            '>',
            " Account ",
            '>',
            " Recover Password")));
};
const mapStateToProps = (state) => ({
    devices: state.appTemp.devices,
});
const connector = connect(mapStateToProps, { ...auth });
export default connector(PasswordRecovery);
